// frontend/modules/sms/index.ts
import { ModuleConfig } from '@/core/module';
import { smsRoutes } from './routes';
import { useSmsStore } from './stores/sms-store';

export const SmsModule: ModuleConfig = {
    name: 'sms',
    routes: smsRoutes,
    stores: {
        sms: useSmsStore
    },
    initialize: () => {
        console.log('SMS module initialized');
    }
};